<template>
  <VModal :isScroll="false">
    <VSpan
      class="immediate-discount-header"
      slot="header"
      text="즉시할인정보"
      :size="16"
      :color="TextColor.darkGray"
      :weight="TextWeight.bold"
    />
    <VBlock slot="contents" :direction="Direction.column" :padding="[10, 0, 0, 0]">
      <VBlock
        v-if="params.discounts.length > 0"
        class="immediate-discount-wrapper"
        ref="scrollLayer"
        :direction="Direction.column"
        :padding="[0, 0, 10, 0]"
        :sort="Sort.left_top"
      >
        <VList>
          <VListItem>
            <VBlock class="immediate-discount-header" :sort="Sort.left_center">
              <VSpan
                class="text"
                text="주문금액"
                :size="14"
                :weight="TextWeight.bold"
                :color="TextColor.darkGray"
              />
              <VSpan
                class="text"
                text="즉시할인"
                :size="14"
                :weight="TextWeight.bold"
                :color="TextColor.darkGray"
              />
            </VBlock>
          </VListItem>
          <VListItem v-for="(discount, index) in params.discounts" :key="index">
            <VBlock class="immediate-discount-contents" :sort="Sort.left_center">
              <VSpan
                class="text"
                :text="`${discount.cause.startAmount}원~`"
                :type="TextType.Number"
                :color="TextColor.darkGray"
                :size="14"
              />
              <VBlock v-if="index === 0" class="text" :sort="Sort.left_center">
                <VSpan
                  class="text"
                  :text="`${discount.discountAmount}원`"
                  :type="TextType.Number"
                  :color="TextColor.darkGray"
                  :size="14"
                />
              </VBlock>
              <VBlock v-else class="text" :sort="Sort.left_center">
                <!-- <strike class="strike">
                <VSpan
                  :text="`${params.discounts[index - 1].discountAmount}원`"
                  :type="TextType.Number"
                  :size="14"
                  :color="TextColor.inactive"
                />
                </strike>-->
                <VSpan
                  :text="`${discount.discountAmount}원`"
                  :type="TextType.Number"
                  :size="14"
                  :color="TextColor.darkGray"
                />
              </VBlock>
            </VBlock>
          </VListItem>
        </VList>
      </VBlock>
      <VBlock
        v-else
        :sort="Sort.left_center"
        class="immediate-discount-wrapper"
        :padding="[0, 0, 10, 0]"
      >
        <VSpan text="즉시할인 정보가 없어요." :color="TextColor.darkGray" :size="14" />
      </VBlock>
      <VBlock class="info-text-wrapper" :padding="[15, 0, 0, 0]">
        <VSpan
          class="info-text"
          text="가게 및 센터 운영방침에 따라 주문금액,배달주소,시간,날씨,교통 등에 의해 배달팁이 변경될 수 있습니다."
          :size="11"
          :color="TextColor.gray2"
        />
      </VBlock>
    </VBlock>
    <VBlock slot="footer" class="button-wrapper">
      <VButton class="cancel-button" :color="ButtonColor.none" :onClick="onOK">
        <VSpan text="확인" :size="16" :color="TextColor.black" :weight="TextWeight.bold" />
      </VButton>
    </VBlock>
  </VModal>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VHR from '@/presentationals/v2/components/layouts/atoms/VHR'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal from '@/presentationals/v2/components/layouts/molecules/VModal'

import VList from '@/presentationals/v2/components/layouts/molecules/VList'
import VListItem from '@/presentationals/v2/components/layouts/molecules/VListItem'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'ModalImmediateDiscount',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  mounted() {
    disableBodyScroll(this.$refs.scrollLayer.$el)
  },
  beforeDestroy() {
    enableBodyScroll(this.$refs.scrollLayer.$el)
  },
  components: {
    VButton,
    VSpan,
    VHR,

    VBlock,
    VModal,

    VList,
    VListItem
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.immediate-discount-wrapper {
  box-sizing: border-box;
  // padding: 10px 0 16px 0;
  border-bottom: 1px solid $light-gray-5;
  max-height: 200px;
  overflow-y: auto;

  .immediate-discount-header {
    margin-bottom: 10px;

    .text {
      text-align: left;

      &:first-child {
        width: 90px;
        margin-right: 10px;
      }
      &:last-child {
        width: 60px;
      }
    }
  }

  .immediate-discount-contents {
    margin-bottom: 5px;

    .text {
      text-align: left;

      &:first-child {
        width: 90px;
        margin-right: 10px;
      }
      &:last-child {
        width: auto;
        text-align: left;

        .strike {
          margin-right: 6px;
        }
      }
    }
  }
}

.info-text-wrapper {
  // padding: 15px 0 0 0;
  box-sizing: border-box;

  .info-text {
    text-align: left;
  }
}

.button-wrapper {
  .cancel-button {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
  }
}
</style>